import {
  Checkbox,
  message,
  Select,
  PageHeader,
  Col,
  Row,
  Spin,
  Form as FormInitial,
  Upload,
  Popconfirm,
  Input,
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  cuentaMask,
  TextAreaItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  extraerDatosConstanciaFiscal,
  calcularSimilitud,
  SwitchItem,
  TabbedDynamicTable,
  DynamicCardForm,
  SelectInsumosItem,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
class AgregarProveedor extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    todasMonedas: null,
    objetoMonedas: null,
    todasPaises: null,
    objetoPaises: null,
    todasEstados: null,
    objetoEstados: null,
    todasMunicipios: null,
    objetoMunicipios: null,
    todasColonias: null,
    objetoColonias: null,
    todasTipoDeProveedor: null,
    objetoTipoDeProveedor: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasBancosSat: null,
    objetoBancosSat: null,
    todasTiposDeOperacion: null,
    objetoTiposDeOperacion: null,
    todasTiposDeTerceros: null,
    objetoTiposDeTerceros: null,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    modalAgregarCuentaContable: false,
    modalAgregarTipoDeProveedor: false,
    factorajeFinancieroCXC: false,
    // Archivos
    archivosProveedor: [],
    filePreviewVisible: false,
    currentPreviewFile: null,
    maximoArchivos: 3,
    objetoMunicipiosDropshipping: null,
    objetoColoniasDropshipping: null,
    todasColoniasDropshipping: null,
    todasPaisesResidencia: null,
    objetoPaisesResidencia: null,
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proveedores/selectDatosParaProveedor",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            todasBancosSat: res.data.bancosSat,
            todasTipoDeProveedor: res.data.tipoDeProveedores,
            todasCuentaContable: res.data.cuentasContables,
            todasMonedas: res.data.monedas,
            todasPaises: res.data.paises,
            todasEstados: res.data.estados,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasRetenciones: res.data.retenciones,
            maximoArchivos: res.data.maximoArchivos,
            todasFormasDePago: res.data.formasDePago,
            objetoUsosDeCFDI: (res.data.usosDeCFDI || []).map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_UsoCFDI + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoFormasDePago: (res.data.formasDePago || []).map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_FormaPago + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.abreviacion + " - " + value.nombre}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoCuentaContable: res.data.cuentasContables.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5,
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
            objetoTipoDeProveedor: res.data.tipoDeProveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoBancosSat: res.data.bancosSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoRetenciones: res.data.retenciones.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasPaisesResidencia: res.data.paisesResidencia,
            objetoPaisesResidencia: res.data.paisesResidencia?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          });
          this.formRef.current.setFieldsValue({
            codigo: res.data.sigNumero,
            clave: res.data.sigNumero,
          });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    // El FormItem "archivos" envuelve un Upload sin valuePropName, asi que values.archivos es
    // el objeto del onChange de antd ({ file, fileList }), no la lista de archivos: se saca del
    // body y se manda lo que si trae el base64, igual que en EditarProveedor.
    const { credencialesProveedor, archivos, ...resto } = values;
    const archivosLimpios = this.state.archivosProveedor.map((archivo) => ({
      name: archivo.name,
      url: archivo.url,
    }));
    axios
      .post(
        "proveedores/agregarProveedor",
        {
          ...resto,
          empresaId: this.props.empresaId,
          archivos: archivosLimpios,
        },
        { headers: this.props.headersToken },
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          if (
            credencialesProveedor &&
            credencialesProveedor.tipo &&
            credencialesProveedor.usuario &&
            credencialesProveedor.password
          ) {
            try {
              await axios.post(
                "requisiciones/configurarCredencialesProveedor",
                {
                  empresaId: this.props.empresaId,
                  proveedorId: res.data.proveedorId,
                  tipo: credencialesProveedor.tipo,
                  usuario: credencialesProveedor.usuario,
                  password: credencialesProveedor.password,
                },
                { headers: this.props.headersToken },
              );
            } catch (err) {
              message.warning(
                "Proveedor creado, pero hubo un error guardando las credenciales del catálogo",
              );
            }
          }
          this.setState({ loading: false });
          message.success("Se ha registrado un proveedor");
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          this.setState({ loading: false });
          message.error(
            res.data.message || "No se puede registrar el proveedor",
          );
        } else {
          this.setState({ loading: false });
          message.error("Hubo un error y el proveedor no se registro");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ cuentaContableId: codigo });
      }
    });
  }
  onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        municipioId: undefined,
        coloniaId: undefined,
      });
      this.setState({ objetoMunicipios: null, objetoColonias: null });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          this.setState({
            objetoMunicipios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  onChangeMunicipio(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({ coloniaId: undefined });
      this.setState({ objetoColonias: null });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          this.setState({
            objetoColonias: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  onSearchColonia(value) {
    if (value.toString().length === 5) {
      axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          },
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            this.formRef.current.setFieldsValue({
              paisId: res.data.paisId,
              estadoId: res.data.estadoId,
              municipioId: res.data.municipioId,
              coloniaId:
                res.data.colonias && res.data.colonias.length > 0
                  ? res.data.colonias[0]._id
                  : undefined,
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }
  onChangeTipoDeProveedor(value) {
    const tipoDeProveedor = this.state.todasTipoDeProveedor.find(
      (valueTodos) => valueTodos._id.toString() === value.toString(),
    );
    if (tipoDeProveedor.generarCuentasAutomatico) {
      this.formRef.current.setFieldsValue({
        cuentaProveedorId: "Se generara al guardarlo",
        cuentaAnticipoId: "Se generara al guardarlo",
        generarCuentaAnticipoId: false,
        cuentaFonGarId: "Se generara al guardarlo",
        generarCuentaFonGarId: false,
        cuentaDeudorId: "Se generara al guardarlo",
        generarCuentaDeudorId: false,
      });
    } else {
      this.formRef.current.setFieldsValue({
        cuentaProveedorId: tipoDeProveedor.cuentaProveedorId,
        cuentaAnticipoId: tipoDeProveedor.cuentaAnticipoId,
        generarCuentaAnticipoId: false,
        cuentaFonGarId: tipoDeProveedor.cuentaFonGarId,
        generarCuentaFonGarId: false,
        cuentaDeudorId: tipoDeProveedor.cuentaDeudorId,
        generarCuentaDeudorId: false,
      });
    }
  }
  onSelectColoniaId(coloniaId) {
    const colonia = this.formRef.current.getFieldValue("colonia");
    if (!colonia) {
      const nombreColonia = this.state.todasColonias.find(
        (todasColonia) => todasColonia._id.toString() === coloniaId.toString(),
      )?.nombre;
      this.formRef.current.setFieldsValue({
        colonia: nombreColonia,
      });
    }
  }
  onChangeRegimenFiscal(regimenFiscalId) {
    const retencionAgregar = this.state.todasRetenciones.find(
      (todasRetenciones) =>
        todasRetenciones.regimenFiscalId.toString() ===
        regimenFiscalId.toString(),
    );
    const retenciones = this.formRef.current.getFieldValue("retenciones");
    if (retencionAgregar) {
      if (retenciones) {
        const findRetencion = retenciones.find(
          (todasRetencionesProv) =>
            todasRetencionesProv.retencionId.toString() ===
            retencionAgregar._id.toString(),
        );
        if (!findRetencion) {
          this.formRef.current.setFieldsValue({
            retenciones: [
              ...retenciones,
              { retencionId: retencionAgregar._id },
            ],
          });
        }
      } else {
        this.formRef.current.setFieldsValue({
          retenciones: [{ retencionId: retencionAgregar._id }],
        });
      }
    }
  }

  async buscarYLlenarUbicacion(codigoPostal, nombreColonia) {
    try {
      // Primero buscar por código postal
      const res = await axios.post(
        "colonias/buscarCP",
        { cp: codigoPostal },
        {
          headers: this.props.headersToken,
        },
      );

      if (res.data.status !== 404) {
        // Llenar país, estado y municipio
        this.formRef.current.setFieldsValue({
          paisId: res.data.paisId,
          estadoId: res.data.estadoId,
          municipioId: res.data.municipioId,
        });

        // Cargar estados y municipios
        this.onChangeEstado(res.data.estadoId, true);
        this.onChangeMunicipio(res.data.municipioId, true);

        // Obtener todas las colonias del municipio
        const coloniasRes = await axios.post(
          "colonias/selectColonias",
          { municipioId: res.data.municipioId },
          {
            headers: this.props.headersToken,
          },
        );

        if (coloniasRes.data.status !== 404) {
          this.setState({
            todasColonias: coloniasRes.data,
            objetoColonias: coloniasRes.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
          });

          // Buscar la colonia exacta por código postal Y nombre
          let coloniaExacta = coloniasRes.data.find(
            (colonia) =>
              colonia.cp === codigoPostal &&
              colonia.nombre.toUpperCase() === nombreColonia.toUpperCase(),
          );

          // Si no se encuentra por nombre exacto, buscar solo por código postal
          if (!coloniaExacta) {
            coloniaExacta = coloniasRes.data.find(
              (colonia) => colonia.cp === codigoPostal,
            );
          }

          // Si aún no se encuentra, buscar por similitud de nombre
          if (!coloniaExacta && nombreColonia) {
            const coloniasPorCP = coloniasRes.data.filter(
              (colonia) => colonia.cp === codigoPostal,
            );
            if (coloniasPorCP.length > 0) {
              // Buscar la colonia con mayor similitud de nombre
              let mejorCoincidencia = coloniasPorCP[0];
              let mejorSimilitud = calcularSimilitud(
                mejorCoincidencia.nombre,
                nombreColonia,
              );

              for (let colonia of coloniasPorCP) {
                const similitud = calcularSimilitud(
                  colonia.nombre,
                  nombreColonia,
                );
                if (similitud > mejorSimilitud) {
                  mejorSimilitud = similitud;
                  mejorCoincidencia = colonia;
                }
              }

              // Solo usar si la similitud es mayor al 70%
              if (mejorSimilitud > 70) {
                coloniaExacta = mejorCoincidencia;
              }
            }
          }

          if (coloniaExacta) {
            this.formRef.current.setFieldsValue({
              coloniaId: coloniaExacta._id,
            });
          } else {
            message.warning(
              `Se encontró el código postal ${codigoPostal} pero no se pudo identificar la colonia "${nombreColonia}" exacta`,
            );
          }
        }
      } else {
        message.info(`No se encontró el código postal ${codigoPostal}`);
      }
    } catch (error) {
      console.error("Error al buscar ubicación:", error);
      message.error("Error al buscar los datos de ubicación");
    }
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (e.file.type === "application/pdf") {
      const datosConstancia = await extraerDatosConstanciaFiscal(e.file);

      if (datosConstancia.persona === 1) {
        if (
          datosConstancia.rfc &&
          datosConstancia.nombre &&
          datosConstancia.apellidoPaterno &&
          datosConstancia.codigoPostal
        ) {
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal,
              ) > 65,
          );

          // Buscar y llenar datos de ubicación
          await this.buscarYLlenarUbicacion(
            datosConstancia.codigoPostal,
            datosConstancia.colonia,
          );

          this.formRef.current.setFieldsValue({
            rfc: datosConstancia.rfc,
            curp: datosConstancia.curp,
            nombre: datosConstancia.nombre,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            apellidoPaterno: datosConstancia.apellidoPaterno,
            apellidoMaterno: datosConstancia.apellidoMaterno,
            nombreComercial: datosConstancia.nombreComercial,
            calle: datosConstancia.calle,
            numeroCalle: datosConstancia.numeroExterior,
            numeroInterior: datosConstancia.numeroInterior,
            colonia: datosConstancia.colonia,
            persona: false,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else if (datosConstancia.persona === 2) {
        if (
          datosConstancia.rfc &&
          datosConstancia.razonSocial &&
          datosConstancia.codigoPostal
        ) {
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal,
              ) > 65,
          );

          // Buscar y llenar datos de ubicación
          await this.buscarYLlenarUbicacion(
            datosConstancia.codigoPostal,
            datosConstancia.colonia,
          );

          this.formRef.current.setFieldsValue({
            razonSocial: datosConstancia.razonSocial,
            rfc: datosConstancia.rfc,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            curp: datosConstancia.curp,
            nombreComercial: datosConstancia.nombreComercial,
            calle: datosConstancia.calle,
            numeroCalle: datosConstancia.numeroExterior,
            numeroInterior: datosConstancia.numeroInterior,
            colonia: datosConstancia.colonia,
            persona: true,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else {
        message.error("No se pudo leer bien el archivo");
      }
    } else {
      message.error("El archivo debe ser un archivo pdf");
    }
    this.setState({ loading: false });
  }

  //Funciones para los archivos
  onRemoveFile(e) {
    let index = this.state.archivosProveedor.indexOf(e);
    let nuevoArray = this.state.archivosProveedor;
    nuevoArray.splice(index, 1);
    this.setState({ archivosProveedor: nuevoArray });
  }
  async customRequestArchivos(e) {
    const file = e.file;
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError("Archivo demasiado grande");
      return;
    }
    const base64 = await getBase64(file);

    const nuevoArchivo = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url: base64,
      originFileObj: file,
    };

    this.setState({
      archivosProveedor: [...this.state.archivosProveedor, nuevoArchivo],
    });

    e.onSuccess("ok");
  }
  beforeUploadArchivos = (file, fileList) => {
    const { archivosProveedor, maximoArchivos } = this.state;
    const totalProyectado = archivosProveedor.length + fileList.length;

    if (totalProyectado > maximoArchivos) {
      if (file === fileList[0]) {
        message.error(
          `Con esta selección, superarías el límite de ${maximoArchivos} archivos.`,
        );
      }
      return Upload.LIST_IGNORE;
    }

    const isLt25M = file.size / 1024 / 1024 < 25;
    if (!isLt25M) {
      message.error(`${file.name} excede el tamaño máximo de 25MB`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  handlePreview = async (file) => {
    // Usar el FilePreviewModal para todos los archivos
    this.setState({
      currentPreviewFile: file,
      filePreviewVisible: true,
    });
  };
  handleCancel = () => this.setState({ previewVisible: false });
  handleCloseFilePreview = () => {
    this.setState({
      filePreviewVisible: false,
      currentPreviewFile: null,
    });
  };

  onChangeEstadoDropshipping(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionDropshipping: {
          ...this.formRef.current.getFieldValue("direccionDropshipping"),
          municipioId: undefined,
          coloniaId: undefined,
        },
      });
      this.setState({
        objetoMunicipiosDropshipping: null,
        objetoColoniasDropshipping: null,
      });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoMunicipiosDropshipping: res.data.map((v) => (
              <Option value={v._id} key={v._id}>
                {v.nombre}
              </Option>
            )),
          });
        }
      });
  }

  onChangeMunicipioDropshipping(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionDropshipping: {
          ...this.formRef.current.getFieldValue("direccionDropshipping"),
          coloniaId: undefined,
        },
      });
      this.setState({ objetoColoniasDropshipping: null });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasColoniasDropshipping: res.data,
            objetoColoniasDropshipping: res.data.map((v) => (
              <Option value={v._id} key={v._id}>
                {v.cp + " - " + v.nombre}
              </Option>
            )),
          });
        }
      });
  }

  onSearchColoniaDropshipping(value) {
    if (value.toString().length === 5) {
      axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.formRef.current.setFieldsValue({
              direccionDropshipping: {
                paisId: res.data.paisId,
                estadoId: res.data.estadoId,
                municipioId: res.data.municipioId,
                coloniaId:
                  res.data.colonias && res.data.colonias.length > 0
                    ? res.data.colonias[0]._id
                    : undefined,
              },
            });
            this.onChangeEstadoDropshipping(res.data.estadoId, true);
            this.onChangeMunicipioDropshipping(res.data.municipioId, true);
          } else {
            message.info("No se encontró el código postal");
          }
        });
    }
  }

  onSelectColoniaIdDropshipping(coloniaId) {
    const direccion = this.formRef.current.getFieldValue(
      "direccionDropshipping",
    );
    if (!direccion?.colonia) {
      const nombreColonia = this.state.todasColoniasDropshipping.find(
        (c) => c._id.toString() === coloniaId.toString(),
      )?.nombre;
      this.formRef.current.setFieldsValue({
        direccionDropshipping: { ...direccion, colonia: nombreColonia },
      });
    }
  }

  render() {
    const { filePreviewVisible, currentPreviewFile } = this.state;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Proveedor"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={[]}
              customRequest={this.onChangeArchivo.bind(this)}
              accept=".pdf"
            >
              <ButtonItem blanco icon={<UploadOutlined />}>
                Leer Constancia
              </ButtonItem>
            </Upload>
          }
        />
        <div className="card-background" style={{ paddingTop: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarProveedor"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  cyan
                  style={{ display: "block", margin: "0 0 0 auto", minWidth: 120, height: 30 }}
                >
                  Guardar Proveedor
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              initialValues={{ monedaId: "60c7e4396465ad440c41c15a" }}
            >
              <TabbedDynamicTable
                defaultActiveKey="1"
                tabs={[
                  {
                    key: '1',
                    label: 'General',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={12} xs={24} sm={24} lg={13} xl={13}>
                            <DynamicCardForm title={<span>Datos Generales</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    name="codigo"
                                    label="Codigo"
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                  >
                                    <InputItem disabled placeholder="Codigo" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="clave"
                                    label="Clave"
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                    pattern
                                  >
                                    <InputItem placeholder="Clave" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="RFC"
                                    name="rfc"
                                    required
                                    margin
                                    rfc
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputItem placeholder="RFC" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="persona"
                                    label="P. Moral"
                                    valuePropName="checked"
                                    initialValue={false}
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                  >
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            label="CURP"
                                            margin
                                            pattern
                                            max={20}
                                            name="curp"
                                            labelCol={{ span: 10 }}
                                            wrapperCol={{ span: 18 }}
                                          >
                                            <InputItem placeholder="Curp" />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  if (getFieldValue("persona")) {
                                    return (
                                      <FormItem
                                        label="Razon Social"
                                        margin
                                        pattern
                                        required
                                        name="razonSocial"
                                        labelCol={{ span: 5 }}
                                        wrapperCol={{ span: 18 }}
                                      >
                                        <InputItem placeholder="Razon Social" />
                                      </FormItem>
                                    );
                                  }
                                }}
                              </FormItem>
                              <Row>
                                <Col span={10}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            label="Nombre"
                                            margin
                                            pattern
                                            required
                                            name="nombre"
                                            labelCol={{ span: 12 }}
                                            wrapperCol={{ span: 12 }}
                                          >
                                            <InputItem
                                              placeholder="Nombre"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            required
                                            name="apellidoPaterno"
                                            labelCol={{ span: 0 }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem
                                              placeholder="Appelido Paterno"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            required
                                            name="apellidoMaterno"
                                            labelCol={{ span: 0 }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem
                                              placeholder="Appellido Materno"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    margin
                                    pattern
                                    max={200}
                                    name="nombreComercial"
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Nombre Comercial</span>}
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <InputItem placeholder="Nombre Comercial" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                                    noStyle
                                  >
                                    {({ getFieldValue }) =>
                                      getFieldValue("rfc") === "XEXX010101000" && (
                                        <Row gutter={[16, 0]}>
                                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                            <FormItem
                                              label="ID Trib."
                                              name="registroIDTributario"
                                              margin
                                              pattern
                                              labelCol={{ span: 5 }}
                                              wrapperCol={{ span: 18 }}
                                              tooltip="Número de Registro de Identificación Tributaria del extranjero"
                                            >
                                              <InputItem placeholder="Ej: VAT-DE123456789" />
                                            </FormItem>
                                          </Col>
                                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                            <FormItem
                                              label="Residencia Fiscal"
                                              name="paisResidenciaId"
                                              margin
                                              labelCol={{ span: 5 }}
                                              wrapperCol={{ span: 18 }}
                                            >
                                              <SelectItem placeholder="Residencia Fiscal">
                                                {this.state.objetoPaisesResidencia}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      )
                                    }
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Datos del Contacto General</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="Celular"
                                    name="celular"
                                    number
                                    margin
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputNumberItem placeholder="Celular" celular />
                                  </FormItem>
                                  <FormItem
                                    label="Telefono"
                                    name="telefono"
                                    number
                                    margin
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputNumberItem placeholder="Telefono" celular />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    label="Correo"
                                    name="correo"
                                    pattern
                                    max={200}
                                    email
                                    margin
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Correo" />
                                  </FormItem>
                                  <FormItem
                                    label="Correos Adicionales"
                                    margin
                                    tooltip="Se precargan al enviar una orden de compra por correo. Los correos que se usen al enviar se agregan aqui solos."
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <FormInitial.List name="correosAdicionales">
                                      {(fields, { add, remove }) => (
                                        <>
                                          {fields.map(({ name }, arrayKey) => (
                                            <Row key={arrayKey} gutter={8} align="middle">
                                              <Col span={20}>
                                                <FormItem
                                                  name={[name, "correo"]}
                                                  fieldKey={[arrayKey, "correo"]}
                                                  required
                                                  margin
                                                  noStyle
                                                  email
                                                  pattern
                                                >
                                                  <InputItem placeholder="Correo" />
                                                </FormItem>
                                              </Col>
                                              <Col span={4}>
                                                <div style={{ textAlign: 'center' }}>
                                                  <ButtonItem
                                                    rojo2
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => remove(name)}
                                                    lessTime
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                          <div style={{ marginTop: 5 }}>
                                            <ButtonItem
                                              blanco={true}
                                              icon={<PlusOutlined />}
                                              onClick={() => add()}
                                              lessTime
                                            >
                                              Agregar correo
                                            </ButtonItem>
                                          </div>
                                        </>
                                      )}
                                    </FormInitial.List>
                                  </FormItem>
                                  <FormItem
                                    label="Pagina Web"
                                    name="paginaWeb"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Pagina Web" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    name="observaciones"
                                    label="Observaciones"
                                    margin
                                    pattern
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <TextAreaItem placeholder="Observaciones" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Contacto del Proveedor</span>}>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Nombre"
                                    name="nombreContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Nombre de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Teléfono"
                                    name="telefonoContacto"
                                    number
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputNumberItem
                                      placeholder="Telefono de Contacto"
                                      celular
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Correo"
                                    name="correoContacto"
                                    pattern
                                    max={200}
                                    email
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Correo de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Personas pedidos</span>}
                                    name="personasPedidos"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Personas que atienden pedidos" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Jefe de Contacto</span>}
                                    name="jefeContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Jefe de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Puesto Jefe Contacto</span>}
                                    name="puestoJefeContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Pueso del Jefe del Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                          </Col>

                          <Col span={12} xs={24} sm={24} lg={11} xl={11}>
                            <DynamicCardForm title={<span>Crédito y Bancos</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="Dias crédito"
                                    name="diasCredito"
                                    numberCero
                                    margin
                                    labelCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 10 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputNumberItem placeholder="Dias de Credito" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    label="Crédito"
                                    name="limiteCredito"
                                    numberCero
                                    margin
                                    labelCol={{ lg: { span: 10 }, xl: { span: 10 }, xs: { span: 4 } }}
                                    wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                  >
                                    <InputNumberItem
                                      dinero
                                      placeholder="Limite de credito"
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                              {this.props.escuela && (
                                <Row>
                                  <Col span={12}>
                                    <FormItem
                                      label="Desc. Predet."
                                      name="descuentoPredeterminado"
                                      numberCero
                                      margin
                                      tooltip="Se precarga como Desc. Prov. en cada renglón de órdenes de compra y facturas de proveedor. En cada operación se le puede sumar un descuento adicional (en cascada)."
                                      labelCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 10 } }}
                                      wrapperCol={{ lg: { span: 12 }, xl: { span: 12 }, xs: { span: 18 } }}
                                    >
                                      <InputNumberItem porcentaje max={100} placeholder="Descuento" />
                                    </FormItem>
                                  </Col>
                                </Row>
                              )}
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Moneda"
                                    name="monedaId"
                                    required
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <SelectItem placeholder="Tipo de Moneda">
                                      {this.state.objetoMonedas}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Banco"
                                    name="bancoSatId"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <SelectItem placeholder="Banco">
                                      {this.state.objetoBancosSat}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Cuenta"
                                    name="cuentaBanco"
                                    number
                                    max={20}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Cuenta de Banco" />
                                  </FormItem>
                                </Col>
                                <Col span={24}>
                                  <FormItem
                                    label="Cuenta Clabe"
                                    name="cuentaClabe"
                                    number
                                    max={18}
                                    min={18}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Cuenta Clabe" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    name="pagoElectronico"
                                    label="Pago electrónico"
                                    valuePropName="checked"
                                    initialValue={true}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Contabilidad</span>}>
                              <FormItem
                                name="proveedorExtranjero"
                                label="P. Extranjero"
                                valuePropName="checked"
                                initialValue={false}
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SwitchItem />
                              </FormItem>
                              <FormItem
                                name="regimenFiscalId"
                                label="R. Fiscal"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  onChange={this.onChangeRegimenFiscal.bind(this)}
                                  placeholder="Regimen Fiscal"
                                >
                                  {this.state.objetoRegimenFiscal}
                                </SelectItem>
                              </FormItem>
                              <FormItem
                                name="usoDeCfdiId"
                                label="Uso de CFDI"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectItem placeholder="Uso de CFDI" allowClear>
                                  {this.state.objetoUsosDeCFDI}
                                </SelectItem>
                              </FormItem>
                              <FormItem
                                name="metodoPago"
                                label="Método de Pago"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  placeholder="Método de Pago"
                                  allowClear
                                  onChange={() => this.formRef.current.setFieldsValue({ formaDePagoId: undefined })}
                                >
                                  <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                                  <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                                </SelectItem>
                              </FormItem>
                              <FormItem noStyle shouldUpdate={(prev, curr) => prev.metodoPago !== curr.metodoPago}>
                                {({ getFieldValue }) => {
                                  const metodoPago = getFieldValue("metodoPago");
                                  const todas = this.state.todasFormasDePago || [];
                                  let filtradas = todas;
                                  if (metodoPago === 2) filtradas = todas.filter(v => v.c_FormaPago === 99);
                                  else if (metodoPago === 1) filtradas = todas.filter(v => v.c_FormaPago !== 99);
                                  return (
                                    <FormItem
                                      name="formaDePagoId"
                                      label="Forma de Pago"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                    >
                                      <SelectItem placeholder="Forma de Pago" allowClear>
                                        {filtradas.map(v => (
                                          <Option value={v._id} key={v._id}>
                                            {v.c_FormaPago + " - " + v.descripcion}
                                          </Option>
                                        ))}
                                      </SelectItem>
                                    </FormItem>
                                  );
                                }}
                              </FormItem>
                              <FormItem
                                name="insumoGastoId"
                                label="Gasto"
                                tooltip="Insumo al que pertenecen por defecto las facturas de este proveedor. Solo prellena la captura rapida de gasto; se puede cambiar al capturar."
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectInsumosItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  tiposInsumos="compra"
                                  width="100%"
                                  dropdownMatchSelectWidth={600}
                                  placeholder="Gasto predeterminado"
                                  allowClear
                                />
                              </FormItem>
                              <FormItem
                                label="T. Proveedor"
                                margin
                                name="tipoProveedorId"
                                required
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  placeholder="Tipo de Proveedor"
                                  onChange={this.onChangeTipoDeProveedor.bind(this)}
                                >
                                  {this.state.objetoTipoDeProveedor}
                                </SelectItem>
                              </FormItem>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                   label="T. Operación DIOT"
                                    name="tipoOperacion"
                                    required
                                    margin
                                    initialValue={3}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <SelectItem placeholder="Tipo de Operación DIOT">
                                      <Option value={1}>
                                        03 - Prestacion de servicios
                                      </Option>
                                      <Option value={2}>
                                        06 - Arrendamiento de inmuebles
                                      </Option>
                                      <Option value={3}>85 - Otros</Option>
                                      <Option value={4}>NA - No asignados</Option>
                                      <Option value={5}>02 - Enajenación de bienes</Option>
                                      <Option value={6}>07 - Importación de bienes o servicios</Option>
                                      <Option value={7}>08 - Importación por transferencia virtual</Option>
                                      <Option value={8}>87 - Operaciones globales</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={24}>
                                  <FormItem
                                    label="T. Tercero DIOT"
                                    name="tipoTercero"
                                    required
                                    margin
                                    initialValue={1}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <SelectItem placeholder="Tipo de Tercero DIOT">
                                      <Option value={1}>
                                        04 - Proveedor Nacional
                                      </Option>
                                      <Option value={2}>
                                        05 - Proveedor Extranjero
                                      </Option>
                                      <Option value={3}>15 - Proveedor Global</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Retenciones</span>}>
                              <FormInitial.List name="retenciones">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "retencionId"]}
                                            fieldKey={[arrayKey, "retencionId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectItem
                                              width="100%"
                                              placeholder="Retención"
                                            >
                                              {this.state.objetoRetenciones}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            <ButtonItem
                                              type="dashed"
                                              rojo2
                                              icon={<DeleteOutlined />}
                                              onClick={() => remove(name)}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 12 }}>
                                      <ButtonItem
                                        type="primary"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Proyectos</span>}>
                              <FormInitial.List name="proyectos">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "proyectoId"]}
                                            fieldKey={[arrayKey, "proyectoId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectProyectosItem
                                              empresaId={this.props.empresaId}
                                              headersToken={this.props.headersToken}
                                              width="100%"
                                              placeholder="Proyecto"
                                            />
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            <ButtonItem
                                              type="dashed"
                                              rojo2
                                              icon={<DeleteOutlined />}
                                              onClick={() => remove(name)}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 12 }}>
                                      <ButtonItem
                                        type="primary"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>

                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Cuentas Contables</span>}>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const tipoDeProveedorId =
                                    getFieldValue("tipoProveedorId");
                                  const tipoDeProveedor = tipoDeProveedorId
                                    ? this.state.todasTipoDeProveedor.find(
                                        (valueTodos) =>
                                          valueTodos._id.toString() ===
                                          tipoDeProveedorId.toString(),
                                      )
                                    : null;
                                  const disabled =
                                    tipoDeProveedor?.generarCuentasAutomatico
                                      ? false
                                      : true;
                                  return (
                                    <Row gutter={16}>
                                      <Col span={24}>
                                        <Row>
                                          <Col span={22}>
                                            <FormItem
                                              label="Proveedor"
                                              name="cuentaProveedorId"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Proveedor"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2}></Col>
                                        </Row>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              name="cuentaAnticipoId"
                                              label="Anticipo"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Anticipo"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaAnticipoId"
                                              valuePropName="checked"
                                              initialValue={true}
                                            >
                                              <Checkbox disabled={disabled}></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col span={24}>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              label="Fondo Garantía."
                                              tooltip="Selecciona primero un tipo de proveedor"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              name="cuentaFonGarId"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Fondo de Gararantia"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaFonGarId"
                                              valuePropName="checked"
                                              initialValue={true}
                                            >
                                              <Checkbox disabled={disabled}></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              label="Acreedor"
                                              name="cuentaDeudorId"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Deudor"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaDeudorId"
                                              valuePropName="checked"
                                              initialValue={true}
                                            >
                                              <Checkbox disabled={disabled}></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  );
                                }}
                              </FormItem>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                  {
                    key: '2',
                    label: 'Dirección',
                    forceRender: true,
                    customContent: (
                      <Row gutter={16}>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <DynamicCardForm title={<span>Ubicación</span>}>
                            <FormItem
                              label="Código Postal"
                              name="coloniaId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Colonia"
                                onSearch={this.onSearchColonia.bind(this)}
                                onSelect={this.onSelectColoniaId.bind(this)}
                              >
                                {this.state.objetoColonias === null ? (
                                  <Option disabled>Eliga primero un municipio</Option>
                                ) : (
                                  this.state.objetoColonias
                                )}
                                <Option disabled>Busque por codigo postal</Option>
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Municipio"
                              name="municipioId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Municipio"
                                onChange={this.onChangeMunicipio.bind(this)}
                              >
                                {this.state.objetoMunicipios === null ? (
                                  <Option disabled>Eliga primero un estado</Option>
                                ) : (
                                  this.state.objetoMunicipios
                                )}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Estado"
                              name="estadoId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Estado"
                                onChange={this.onChangeEstado.bind(this)}
                              >
                                {this.state.objetoEstados}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Pais"
                              name="paisId"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem placeholder="Pais">
                                {this.state.objetoPaises}
                              </SelectItem>
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <DynamicCardForm title={<span>Domicilio</span>}>
                            <FormItem
                              name="colonia"
                              label="Colonia"
                              margin
                              pattern
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Colonia" />
                            </FormItem>
                            <FormItem
                              label="Calle"
                              name="calle"
                              max={200}
                              margin
                              pattern
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Calle" />
                            </FormItem>
                            <FormItem
                              label="Numero"
                              name="numeroCalle"
                              margin
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Numero" numeroCalle />
                            </FormItem>
                            <FormItem
                              label="Numero Interior"
                              name="numeroInterior"
                              margin
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Numero Interior" numeroCalle />
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: '3',
                    label: 'Complementos',
                    forceRender: true,
                    customContent: (
                      <Row gutter={16}>
                        <Col span={12} xs={24} sm={24} lg={8} xl={8}>
                          {this.state.factorajeFinancieroCXC ? (
                            <DynamicCardForm title={<span>Factoraje Financiero</span>}>
                              <FormItem
                                label="Activar Factoraje Financiero"
                                name="factorajeFinancieroCXC"
                                margin
                                valuePropName="checked"
                                tooltip="Al activar esta casilla se activa el factoraje financiero para este proveedor."
                                labelCol={{ span: 14 }}
                                wrapperCol={{ span: 10 }}
                              >
                                <SwitchItem />
                              </FormItem>
                            </DynamicCardForm>
                          ) : null}
                          </Col>

                        <Col span={17} xs={24} sm={24} lg={16} xl={16}>

                          <DynamicCardForm title={<span>Configuración Dropshipping</span>}>
                            <FormItem
                              label="¿Es proveedor Dropshipping?"
                              name="esDropshipping"
                              valuePropName="checked"
                              margin
                              labelCol={{ lg: { span: 6}, xl: { span: 6}, sm: { span: 14 }, xs: { span: 14 } }} 
                              wrapperCol={{ span: 12 }}
                            >
                              <SwitchItem />
                            </FormItem>

                            <FormItem
                              shouldUpdate={(prev, curr) =>
                                prev.esDropshipping !== curr.esDropshipping
                              }
                              noStyle
                            >
                              {({ getFieldValue }) =>
                                getFieldValue("esDropshipping") && (
                                  <>
                                    <FormItem
                                      label="Empresa Dropshipping"
                                      name="empresaDropshipping"
                                      required
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 18 }}
                                    >
                                      <SelectItem placeholder="Seleccionar Empresa">
                                        <Option value="URREA">URREA</Option>
                                      </SelectItem>
                                    </FormItem>

                                    <Row gutter={16}>
                                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                        <FormItem
                                          label="Código Postal"
                                          name={["direccionDropshipping", "coloniaId"]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            placeholder="CP"
                                            onSearch={this.onSearchColoniaDropshipping.bind(
                                              this,
                                            )}
                                            onSelect={this.onSelectColoniaIdDropshipping.bind(
                                              this,
                                            )}
                                          >
                                            {this.state.objetoColoniasDropshipping || (
                                              <Option disabled>Busque por CP</Option>
                                            )}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Municipio"
                                          name={[
                                            "direccionDropshipping",
                                            "municipioId",
                                          ]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            onChange={this.onChangeMunicipioDropshipping.bind(
                                              this,
                                            )}
                                            placeholder="Municipio"
                                          >
                                            {this.state
                                              .objetoMunicipiosDropshipping || (
                                              <Option disabled>Elija un estado</Option>
                                            )}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Estado"
                                          name={["direccionDropshipping", "estadoId"]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            onChange={this.onChangeEstadoDropshipping.bind(
                                              this,
                                            )}
                                            placeholder="Estado"
                                          >
                                            {this.state.objetoEstados}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Pais"
                                          name={["direccionDropshipping", "paisId"]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem placeholder="Pais">
                                            {this.state.objetoPaises}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Colonia"
                                          name={["direccionDropshipping", "colonia"]}
                                          margin
                                          pattern
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <InputItem placeholder="Colonia" />
                                        </FormItem>
                                      </Col>
                                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                        <FormItem
                                          label="Calle"
                                          name={["direccionDropshipping", "calle"]}
                                          margin
                                          pattern
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <InputItem placeholder="Calle" />
                                        </FormItem>
                                        <FormItem
                                          label="Número"
                                          name={[
                                            "direccionDropshipping",
                                            "numeroCalle",
                                          ]}
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <InputItem
                                            placeholder="Num. Ext"
                                            numeroCalle
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Num. Int"
                                          name={[
                                            "direccionDropshipping",
                                            "numeroInterior",
                                          ]}
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <InputItem
                                            placeholder="Num. Int"
                                            numeroCalle
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Correo"
                                          name={["direccionDropshipping", "correo"]}
                                          margin
                                          pattern
                                          email
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <InputItem placeholder="Correo dropshipping" />
                                        </FormItem>
                                        <FormItem
                                          label="Teléfono"
                                          name={["direccionDropshipping", "telefono"]}
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <InputNumberItem
                                            placeholder="Teléfono"
                                            celular
                                          />
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </>
                                )
                              }
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  ...(this.props.consultarProveedoresOnline
                    ? [
                        {
                          key: '5',
                          label: 'Acceso a Catálogo',
                          forceRender: true,
                          customContent: (
                            <Row gutter={16}>
                              <Col span={24} xs={24} sm={24} lg={12} xl={12}>
                                <DynamicCardForm title={<span>Acceso a Catálogo</span>}>
                                  <FormItem
                                    label="Tipo"
                                    name={["credencialesProveedor", "tipo"]}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <SelectItem placeholder="Tipo de catálogo" allowClear>
                                      <Option value="levic">Levic</Option>
                                      <Option value="nadro">Nadro</Option>
                                      <Option value="rosario">Rosario</Option>
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem
                                    label="Usuario"
                                    name={["credencialesProveedor", "usuario"]}
                                    margin
                                    max={100}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Usuario del catálogo" />
                                  </FormItem>
                                  <FormItem
                                    label="Contraseña"
                                    name={["credencialesProveedor", "password"]}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <Input.Password
                                      placeholder="Contraseña"
                                      autoComplete="new-password"
                                    />
                                  </FormItem>
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  {
                    key: '4',
                    label: 'Archivos',
                    customContent: (
                      <Row gutter={16}>
                        <Col span={24}>
                          <DynamicCardForm title={<span>Archivos del Proveedor</span>}>
                            <FormItem
                              name="archivos"
                              margin
                              style={{
                                display: "block",
                                justifyContent: "flex-start",
                                alignItems: "initial",
                                textAlign: "left",
                              }}
                            >
                              <Upload
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="¿Seguro que quieres eliminar el archivo?"
                                      onConfirm={() => {
                                        this.onRemoveFile(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined
                                        onClick={(e) => e.preventDefault()}
                                      />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosProveedor}
                                customRequest={this.customRequestArchivos.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                                beforeUpload={this.beforeUploadArchivos}
                              >
                                <ButtonItem
                                  icon={<UploadOutlined />}
                                  style={{ padding: "0px 45px" }}
                                  disabled={
                                    this.state.archivosProveedor.length >=
                                    this.state.maximoArchivos
                                  }
                                >
                                  Agregar archivos
                                </ButtonItem>
                              </Upload>
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
              />
            </Form>
          </Spin>
        </div>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this,
          )}
        />
        <ModalPrevisualizarArchivos
          file={currentPreviewFile}
          proveedorId={this.state.id}
          visible={filePreviewVisible}
          onClose={this.handleCloseFilePreview}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
    consultarProveedoresOnline: state.empresa.consultarProveedoresOnline,
    escuela: state.empresa.escuela,
  };
};

export default connect(mapStateToProps)(AgregarProveedor);
